import React from 'react';
import { useTranslation } from 'react-i18next';

import { Span } from '@sopranodesign/pulse-components';

import { useDelivery, useQuery } from '../../hooks/index';
import { VERSION } from '../../constants';

const Version = () => {
  const { base_url } = useDelivery();

  const { t } = useTranslation('bots');

  const { data, isSuccess } = useQuery({
    queryKey: [
      'pulse/version'
    ],
    baseUrl: `${base_url}/api`
  });

  if (!isSuccess) {
    return null;
  }

  return (
    <Span tinyText data-testid="version-label">
      {t('setting_version_label')}{' '}
      <span style={{ unicodeBidi: 'isolate', direction: 'ltr' }}>
        {VERSION} ({data.version})
      </span>
    </Span>
  );
};

export default Version;
